<template>
    <tbody>
        <tr @click="toggleOpen" style="cursor: pointer">
            <td>
                <i class="fas fa-caret-down" v-if="open"></i>
                <i class="fas fa-caret-right" v-if="!open"></i>
            </td>
            <fulfillment-cell :row="row" :column="col" v-for="col in columns" :key="row.id+';'+col.id"/>
        </tr>
        <tr v-for="row in row.campaigns" v-if="open" class="inner-ff-campaign">
            <td></td>
            <fulfillment-cell :row="row" :column="col" v-for="col in columns" :key="row.id+';'+col.id"/>
        </tr>
    </tbody>
</template>

<script>
import FulfillmentCell from "./fulfillment-cell";
export default {
    components: {FulfillmentCell},
    props: [
        'row',
        'columns'
    ],
    data() {
        return {
            open: false
        };
    },
    methods: {
        toggleOpen() {
            this.open = !this.open;
        }
    }
}
</script>

<style>
</style>